export default "__VITE_ASSET__27adbda3__"